import { render, staticRenderFns } from "./FixedAsset.yaml?vue&type=template&id=3ace4343&component"
import script from "./FixedAsset.yaml?vue&type=script&lang=ts&component"
export * from "./FixedAsset.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports